// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* SQL Editor Styles */
.sql-editor-container {
  position: fixed;
  top: 0;
  right: 0;
  width: 450px;
  height: 100vh;
  background-color: #ffffff;
  border-left: 1px solid #e1e5e9;
  border-radius: 2px 0 0 2px;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  box-shadow: -2px 0 10px rgba(0, 0, 0, 0.1);
}

.sql-editor-toggle {
  position: fixed;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  background: linear-gradient(135deg, #3f49a7 0%, #6366f1 100%);
  color: #fff;
  border-radius: 2px 0 0 2px;
  padding: 8px 6px;
  z-index: 999;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  box-shadow: 0 2px 8px rgba(99, 102, 241, 0.3);
  min-width: auto;
  width: 32px;
  height: 32px;
}

.sql-editor-toggle:hover {
  background: linear-gradient(135deg, #2e357a 0%, #4f46e5 100%);
  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.4);
  transform: translateY(-50%) scale(1.05);
}

.sql-editor-toggle.expanded {
  right: 450px;
}

.sql-editor-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border-bottom: 1px solid #e1e5e9;
  color: #1e293b;
  font-weight: 600;
}

.sql-editor-content {
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background-color: #ffffff;
}

.sql-editor-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border-top: 1px solid #e1e5e9;
  color: #64748b;
}

.sql-editor-execute-btn {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 8px 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 600;
  font-size: 13px;
  height: 32px;
  min-width: auto;
  transition: all 0.2s ease-in-out;
  box-shadow: 0 2px 4px rgba(16, 185, 129, 0.2);
}

.sql-editor-execute-btn:hover {
  background: linear-gradient(135deg, #059669 0%, #047857 100%);
  box-shadow: 0 4px 8px rgba(16, 185, 129, 0.3);
  transform: translateY(-1px);
}

.sql-editor-execute-btn:disabled {
  background: linear-gradient(135deg, #9ca3af 0%, #6b7280 100%);
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

/* CodeMirror custom styles - ensure height chain for scrollbar */
.cm-editor {
  height: 100% !important;
  min-height: 0 !important;
  display: flex !important;
  flex-direction: column !important;
  font-size: 14px !important;
  font-family: "JetBrains Mono", "Fira Code", "Monaco", "Menlo", "Ubuntu Mono",
    monospace !important;
}

.cm-editor .cm-scroller {
  font-family: "JetBrains Mono", "Fira Code", "Monaco", "Menlo", "Ubuntu Mono",
    monospace !important;
  line-height: 1.6 !important;
  flex: 1 1 !important;
  min-height: 0 !important;
  overflow-x: auto !important;
  overflow-y: scroll !important;
  scrollbar-gutter: stable;
}

.cm-editor .cm-content {
  padding: 16px !important;
}

/* Light theme for CodeMirror */
.cm-theme-light {
  background-color: #ffffff !important;
  color: #1e293b !important;
}

.cm-theme-light .cm-gutters {
  background-color: #f8fafc !important;
  color: #64748b !important;
  border-right: 1px solid #e1e5e9 !important;
}

.cm-theme-light .cm-activeLineGutter {
  background-color: #f1f5f9 !important;
  color: #1e293b !important;
}

.cm-theme-light .cm-activeLine {
  background-color: #f8fafc !important;
}

.cm-theme-light .cm-cursor {
  border-left-color: #1e293b !important;
  border-left-width: 2px !important;
}

/* SQL Syntax Highlighting for Light Theme */
.cm-theme-light .cm-keyword {
  color: #dc2626 !important;
  font-weight: 600 !important;
}

.cm-theme-light .cm-operator {
  color: #7c3aed !important;
}

.cm-theme-light .cm-string {
  color: #2563eb !important;
}

.cm-theme-light .cm-number {
  color: #059669 !important;
}

.cm-theme-light .cm-comment {
  color: #64748b !important;
  font-style: italic !important;
}

.cm-theme-light .cm-variable {
  color: #ea580c !important;
}

.cm-theme-light .cm-property {
  color: #2563eb !important;
}

/* Scrollbar styling */
.cm-editor .cm-scroller::-webkit-scrollbar {
  width: 8px;
}

.cm-editor .cm-scroller::-webkit-scrollbar-track {
  background: #f8fafc;
}

.cm-editor .cm-scroller::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}

.cm-editor .cm-scroller::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

.cm-line.cm-errorLine {
  background-color: rgba(239, 68, 68, 0.18) !important;
  box-shadow: inset 4px 0 0 #ef4444;
}
.cm-line.cm-errorLine.cm-activeLine {
  background-color: rgba(239, 68, 68, 0.24) !important;
}

/* Fake a red gutter bar by adding a left border on the line content */
.cm-errorLine .cm-content,
.cm-errorLine .cm-line {
  position: relative;
}

.cm-errorLine::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  z-index: 1;
  background: #ef4444;
}

/* Optional: emphasize the line number too */
.cm-gutters {
  border-right: 1px solid #e5e7eb;
}

/* Selection highlight (CodeMirror draws selection via .cm-selectionLayer/.cm-selectionBackground) */
.cm-editor .cm-selectionLayer {
  /* Keep selection visible even on the active line */
  z-index: 3 !important;
}

.cm-editor .cm-content {
  position: relative;
  z-index: 2;
}

.cm-editor .cm-cursorLayer {
  z-index: 4 !important;
}

.cm-editor .cm-selectionBackground {
  background-color: rgba(59, 130, 246, 0.35) !important;
}

`, "",{"version":3,"sources":["webpack://./src/components/SqlEditor/SqlEditor.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,8BAA8B;EAC9B,0BAA0B;EAC1B,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,QAAQ;EACR,2BAA2B;EAC3B,6DAA6D;EAC7D,WAAW;EACX,0BAA0B;EAC1B,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,gCAAgC;EAChC,6CAA6C;EAC7C,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;EACE,6DAA6D;EAC7D,8CAA8C;EAC9C,uCAAuC;AACzC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,6DAA6D;EAC7D,gCAAgC;EAChC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,6DAA6D;EAC7D,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,gCAAgC;EAChC,6CAA6C;AAC/C;;AAEA;EACE,6DAA6D;EAC7D,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA,iEAAiE;AACjE;EACE,uBAAuB;EACvB,wBAAwB;EACxB,wBAAwB;EACxB,iCAAiC;EACjC,0BAA0B;EAC1B;wBACsB;AACxB;;AAEA;EACE;wBACsB;EACtB,2BAA2B;EAC3B,oBAAsB;EACtB,wBAAwB;EACxB,2BAA2B;EAC3B,6BAA6B;EAC7B,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,+BAA+B;AAC/B;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;EACrC,iCAAiC;AACnC;;AAEA,4CAA4C;AAC5C;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oDAAoD;EACpD,iCAAiC;AACnC;AACA;EACE,oDAAoD;AACtD;;AAEA,sEAAsE;AACtE;;EAEE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,SAAS;EACT,UAAU;EACV,UAAU;EACV,mBAAmB;AACrB;;AAEA,4CAA4C;AAC5C;EACE,+BAA+B;AACjC;;AAEA,oGAAoG;AACpG;EACE,mDAAmD;EACnD,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qDAAqD;AACvD","sourcesContent":["/* SQL Editor Styles */\n.sql-editor-container {\n  position: fixed;\n  top: 0;\n  right: 0;\n  width: 450px;\n  height: 100vh;\n  background-color: #ffffff;\n  border-left: 1px solid #e1e5e9;\n  border-radius: 2px 0 0 2px;\n  z-index: 1000;\n  display: flex;\n  flex-direction: column;\n  box-shadow: -2px 0 10px rgba(0, 0, 0, 0.1);\n}\n\n.sql-editor-toggle {\n  position: fixed;\n  top: 50%;\n  right: 0;\n  transform: translateY(-50%);\n  background: linear-gradient(135deg, #3f49a7 0%, #6366f1 100%);\n  color: #fff;\n  border-radius: 2px 0 0 2px;\n  padding: 8px 6px;\n  z-index: 999;\n  border: none;\n  cursor: pointer;\n  transition: all 0.3s ease-in-out;\n  box-shadow: 0 2px 8px rgba(99, 102, 241, 0.3);\n  min-width: auto;\n  width: 32px;\n  height: 32px;\n}\n\n.sql-editor-toggle:hover {\n  background: linear-gradient(135deg, #2e357a 0%, #4f46e5 100%);\n  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.4);\n  transform: translateY(-50%) scale(1.05);\n}\n\n.sql-editor-toggle.expanded {\n  right: 450px;\n}\n\n.sql-editor-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 20px;\n  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);\n  border-bottom: 1px solid #e1e5e9;\n  color: #1e293b;\n  font-weight: 600;\n}\n\n.sql-editor-content {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  background-color: #ffffff;\n}\n\n.sql-editor-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 20px;\n  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);\n  border-top: 1px solid #e1e5e9;\n  color: #64748b;\n}\n\n.sql-editor-execute-btn {\n  background: linear-gradient(135deg, #10b981 0%, #059669 100%);\n  color: #fff;\n  border: none;\n  border-radius: 6px;\n  padding: 8px 16px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-weight: 600;\n  font-size: 13px;\n  height: 32px;\n  min-width: auto;\n  transition: all 0.2s ease-in-out;\n  box-shadow: 0 2px 4px rgba(16, 185, 129, 0.2);\n}\n\n.sql-editor-execute-btn:hover {\n  background: linear-gradient(135deg, #059669 0%, #047857 100%);\n  box-shadow: 0 4px 8px rgba(16, 185, 129, 0.3);\n  transform: translateY(-1px);\n}\n\n.sql-editor-execute-btn:disabled {\n  background: linear-gradient(135deg, #9ca3af 0%, #6b7280 100%);\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n/* CodeMirror custom styles - ensure height chain for scrollbar */\n.cm-editor {\n  height: 100% !important;\n  min-height: 0 !important;\n  display: flex !important;\n  flex-direction: column !important;\n  font-size: 14px !important;\n  font-family: \"JetBrains Mono\", \"Fira Code\", \"Monaco\", \"Menlo\", \"Ubuntu Mono\",\n    monospace !important;\n}\n\n.cm-editor .cm-scroller {\n  font-family: \"JetBrains Mono\", \"Fira Code\", \"Monaco\", \"Menlo\", \"Ubuntu Mono\",\n    monospace !important;\n  line-height: 1.6 !important;\n  flex: 1 1 0 !important;\n  min-height: 0 !important;\n  overflow-x: auto !important;\n  overflow-y: scroll !important;\n  scrollbar-gutter: stable;\n}\n\n.cm-editor .cm-content {\n  padding: 16px !important;\n}\n\n/* Light theme for CodeMirror */\n.cm-theme-light {\n  background-color: #ffffff !important;\n  color: #1e293b !important;\n}\n\n.cm-theme-light .cm-gutters {\n  background-color: #f8fafc !important;\n  color: #64748b !important;\n  border-right: 1px solid #e1e5e9 !important;\n}\n\n.cm-theme-light .cm-activeLineGutter {\n  background-color: #f1f5f9 !important;\n  color: #1e293b !important;\n}\n\n.cm-theme-light .cm-activeLine {\n  background-color: #f8fafc !important;\n}\n\n.cm-theme-light .cm-cursor {\n  border-left-color: #1e293b !important;\n  border-left-width: 2px !important;\n}\n\n/* SQL Syntax Highlighting for Light Theme */\n.cm-theme-light .cm-keyword {\n  color: #dc2626 !important;\n  font-weight: 600 !important;\n}\n\n.cm-theme-light .cm-operator {\n  color: #7c3aed !important;\n}\n\n.cm-theme-light .cm-string {\n  color: #2563eb !important;\n}\n\n.cm-theme-light .cm-number {\n  color: #059669 !important;\n}\n\n.cm-theme-light .cm-comment {\n  color: #64748b !important;\n  font-style: italic !important;\n}\n\n.cm-theme-light .cm-variable {\n  color: #ea580c !important;\n}\n\n.cm-theme-light .cm-property {\n  color: #2563eb !important;\n}\n\n/* Scrollbar styling */\n.cm-editor .cm-scroller::-webkit-scrollbar {\n  width: 8px;\n}\n\n.cm-editor .cm-scroller::-webkit-scrollbar-track {\n  background: #f8fafc;\n}\n\n.cm-editor .cm-scroller::-webkit-scrollbar-thumb {\n  background: #cbd5e1;\n  border-radius: 4px;\n}\n\n.cm-editor .cm-scroller::-webkit-scrollbar-thumb:hover {\n  background: #94a3b8;\n}\n\n.cm-line.cm-errorLine {\n  background-color: rgba(239, 68, 68, 0.18) !important;\n  box-shadow: inset 4px 0 0 #ef4444;\n}\n.cm-line.cm-errorLine.cm-activeLine {\n  background-color: rgba(239, 68, 68, 0.24) !important;\n}\n\n/* Fake a red gutter bar by adding a left border on the line content */\n.cm-errorLine .cm-content,\n.cm-errorLine .cm-line {\n  position: relative;\n}\n\n.cm-errorLine::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  width: 4px;\n  z-index: 1;\n  background: #ef4444;\n}\n\n/* Optional: emphasize the line number too */\n.cm-gutters {\n  border-right: 1px solid #e5e7eb;\n}\n\n/* Selection highlight (CodeMirror draws selection via .cm-selectionLayer/.cm-selectionBackground) */\n.cm-editor .cm-selectionLayer {\n  /* Keep selection visible even on the active line */\n  z-index: 3 !important;\n}\n\n.cm-editor .cm-content {\n  position: relative;\n  z-index: 2;\n}\n\n.cm-editor .cm-cursorLayer {\n  z-index: 4 !important;\n}\n\n.cm-editor .cm-selectionBackground {\n  background-color: rgba(59, 130, 246, 0.35) !important;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
